import React from 'react';
import { Tag } from '../../types';
import { TagPill } from '../ui/TagPill';

interface ActiveTagChipsProps {
  tags: Tag[];
  onRemove: (tagId: string) => void;
  onClearAll?: () => void;
}

/**
 * Removable chip row shown when one or more tags are selected.
 * Each chip is a colored TagPill with a trailing × button.
 */
export const ActiveTagChips: React.FC<ActiveTagChipsProps> = ({ tags, onRemove, onClearAll }) => {
  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-3">
      {tags.map((tag) => (
        <TagPill
          key={tag.id}
          tag={tag}
          size="md"
          onRemove={() => onRemove(tag.id)}
        />
      ))}
      {onClearAll && tags.length > 1 && (
        <button
          type="button"
          onClick={onClearAll}
          className="text-xs font-medium text-gray-500 hover:text-gray-900 underline underline-offset-2 ml-1"
        >
          Clear all
        </button>
      )}
    </div>
  );
};
